import { z } from "zod";

import {
  TaskPriority,
  TaskStatus,
} from "@fartherfinance/frontend/api/Tasks/Types";

// Branded ID for virtual tasks to distinguish from regular task IDs
const VirtualTaskId = z.string().brand("VirtualTaskId");
type VirtualTaskId = z.infer<typeof VirtualTaskId>;

// Main VirtualTask interface with branded ID
export interface VirtualTask {
  id: VirtualTaskId;
  title: string;
  taskStatus: TaskStatus;
  children: VirtualTask[];
  /** Indicates this task is one of the predefined root tasks */
  isRoot?: boolean;
  description?: string;
  dueDate?: Date | null;
  taskPriority?: TaskPriority;
  taskType?: { label: string; value: string } | null;
  advisorId?: string;
  assignee?: { label: string; value: string } | null;
  clientId?: string | null;
  serviceTeam?: { label: string; value: string } | null;
  custodian?: string | null;
  isNew?: boolean;
}

// Helper function to create a branded VirtualTaskId
export function createVirtualTaskId(id: string): VirtualTaskId {
  return VirtualTaskId.parse(id);
}
